<template>
    <div class="page mescroll-touch">
        <img src="../../assets/images/acmedback.png" class="topimg" alt="" />
        <div class="totle">
            <div class="maintitle">恭喜完成线上申请!</div>
            <div class="maininner">缴费核实后申请即完成</div>
            <div class="maininner">ACMED入会证书</div>
            <div class="maininnerbold">将于年会现场发放!</div>
            <div class="qrcode">
                <img src="../../assets/images/payokqr.png" class="okqrcode" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    name: 'newpayok',
    data() {
        return {

        }
    },
    computed: {
    },
    created() {
        document.title = "加入ACMED";
    },
    beforeDestroy() {

    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.page {
    width: 100%;
    height: 100%;
    // position: relative;
    background: rgb(247, 249, 253);
}

.totle {
    position: relative;
    width: 100%;
    // top: 47%;
    // transform: translateY(-50%);
    text-align: center;
    z-index: 100;
    padding-top: 3rem;
    padding-bottom: 1rem;
}

.maintitle {
    margin: auto;
    text-align: center;
    font-size: 25px;
    font-weight: bold;
    margin-bottom: .5rem;
    color: rgb(180, 45, 41);
}

.okqrcode {
    display: block;
    margin: auto;
    width: 50%;
    margin-top: 1rem;
}

.maininner {
    width: 73%;
    margin: auto;
    font-size: 20px;
    color: rgb(32, 43, 88);
}

.maininnerbold {
    width: 73%;
    margin: auto;
    font-size: 20px;
    color: rgb(32, 43, 88);
    font-weight: bold;
}

.topimg {
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
}
</style>